export class LocalForageStorage {
  static STORED_APIS = [
    "validator/getbysearchkeyv2/console_conf",
    "translationsDownload",
    "calculationengine/performancecolors",
  ];
}
